import { UpdatePowerBISecretSettingPutModel, UpdatePowerBITenantSettingPutModel } from "@app/data/engine.ts";
import { usePowerBiSettingsData } from "@app/data-hooks/use-power-bi-settings-data.ts";
import { Button, Grid2, TextField } from "@mui/material";
import { useForm } from "@tanstack/react-form";

export function PowerBiForm() {
    const { powerBiSettings, updatePowerBiTenant, updatePowerBiSecret } = usePowerBiSettingsData();

    const form = useForm({
        defaultValues: {
            powerBITenantGuid: powerBiSettings.data?.powerBITenantGuid,
            powerBIClientGuid: powerBiSettings.data?.powerBIClientGuid,
            powerBIClientSecret: undefined,
            powerBIUserOverride: powerBiSettings.data?.powerBIUserOverride,
        } as UpdatePowerBITenantSettingPutModel & UpdatePowerBISecretSettingPutModel,
        onSubmit: async ({ value }) => {
            if (powerBiSettings.data?.powerBISettingID == undefined) {
                console.error("No power bi settings");
                return;
            }
            await updatePowerBiTenant.mutateAsync({ id: powerBiSettings.data.powerBISettingID, data: value });
            if (value.powerBIClientSecret != undefined) {
                await updatePowerBiSecret.mutateAsync({ id: powerBiSettings.data.powerBISettingID, data: value });
            }
        },
    });

    return (
        <form
            onSubmit={(e) => {
                e.preventDefault();
                e.stopPropagation();
                void form.handleSubmit();
            }}
        >
            <Grid2 container spacing={2}>
                <Grid2 size={{ xs: 12, md: 6 }}>
                    <TextField
                        label={"Server URL"}
                        value={powerBiSettings.data?.powerBIServerUrl ?? ""}
                        disabled
                        fullWidth
                        required
                    />
                </Grid2>
                <Grid2 size={{ xs: 12, md: 6 }}>
                    <TextField
                        label={"Authority URL"}
                        value={powerBiSettings.data?.powerBIAuthorityUrl ?? ""}
                        disabled
                        fullWidth
                        required
                    />
                </Grid2>
                <Grid2 size={{ xs: 12, md: 6 }}>
                    <TextField
                        label={"Workspace GUID"}
                        value={powerBiSettings.data?.powerBIWorkspaceGuid ?? ""}
                        disabled
                        fullWidth
                        required
                    />
                </Grid2>
                <Grid2 size={{ xs: 12, md: 6 }}>
                    <form.Field name={"powerBITenantGuid"}>
                        {(field) => (
                            <TextField
                                label={"Tenant GUID"}
                                value={field.state.value ?? ""}
                                fullWidth
                                onChange={(e) => field.handleChange(e.target.value)}
                                required
                            />
                        )}
                    </form.Field>
                </Grid2>
                <Grid2 size={{ xs: 12, md: 6 }}>
                    <form.Field name={"powerBIClientGuid"}>
                        {(field) => (
                            <TextField
                                label={"Client GUID"}
                                value={field.state.value ?? ""}
                                fullWidth
                                onChange={(e) => field.handleChange(e.target.value)}
                                required
                            />
                        )}
                    </form.Field>
                </Grid2>
                <Grid2 size={{ xs: 12, md: 6 }}>
                    <form.Field name={"powerBIClientSecret"}>
                        {(field) => (
                            <TextField
                                label={"Client Secret"}
                                type={"password"}
                                value={field.state.value ?? ""}
                                fullWidth
                                onChange={(e) => field.handleChange(e.target.value)}
                            />
                        )}
                    </form.Field>
                </Grid2>
                <Grid2 size={{ xs: 12, md: 6 }}>
                    <form.Field name={"powerBIUserOverride"}>
                        {(field) => (
                            <TextField
                                label={"User Override"}
                                value={field.state.value ?? ""}
                                fullWidth
                                onChange={(e) => field.handleChange(e.target.value)}
                                required
                            />
                        )}
                    </form.Field>
                </Grid2>
            </Grid2>
            <Button type={"submit"} variant={"contained"} sx={{ mt: 2 }}>
                Save
            </Button>
        </form>
    );
}
